// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper/modules';
//import SwiperAnimation from '@cycjimmy/swiper-animation';
/* import "animate.css" */

const $ = window.jQuery;

const heroSwiper = {
	init() {
		const $heroSwiper = $(document).find('#heroSwiper');
		if (!$heroSwiper.length) return;

		const $slides = $heroSwiper.find('.swiper-slide');
		if (!$slides.length) return;

		//const swiperAnimation = new SwiperAnimation();
		Swiper.use([Navigation, Pagination, Autoplay, Mousewheel]);

		const swiper = new Swiper('#heroSwiper', {
			slidesPerView: 1,
			spaceBetween: 0,
			cache: true,
			loop: false,
			infinit: false,
			mousewheel: {
				forceToAxis: true,
			},
			autoplay: {
				delay: 6500,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			on: {
				init: function (swiper) {
					// set auto play to false
					swiper.autoplay.stop();

					const videoElements = swiper.el.querySelectorAll('video');
					videoElements.forEach((videoElement) => {
						videoElement.addEventListener('play', function () {
							console.log('play');
							swiper.autoplay.stop();
						});
						videoElement.addEventListener('ended', function () {
							// pause video and restart it
							this.pause();
							this.currentTime = 0;
							swiper.autoplay.start();
							// got to next slide

							// if is last slide restart
							if (swiper.isEnd) {
								swiper.slideTo(0);
							} else {
								swiper.slideNext();
							}
						});
					});
				},
				slideChange: function (swiper) {
					// get  current slide
					const currentSlide = swiper.slides[swiper.activeIndex];
					const currentSlideType = $(currentSlide).attr('data-type');
					if (currentSlideType == 'video') {
						const vidEl = $(currentSlide).find('video');
						vidEl[0].currentTime = 0;
						vidEl[0].load();
						vidEl[0].play();
					}
				},
			},
		});
	},
};

export default heroSwiper;
